// src/pages/CurrentPostageAccounts.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchPostageAccountsByOwnerNetId, fetchPostageAccountsByAuthorizedUserNetId } from '../services/api';
import AccountTable from '../components/AccountTable';

function CurrentPostageAccounts() {
    const { netId } = useParams();
    const [ownedAccounts, setOwnedAccounts] = useState([]);
    const [authorizedAccounts, setAuthorizedAccounts] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchPostageAccountsByOwnerNetId(netId)
            .then(setOwnedAccounts)
            .catch(error => {
                console.error('Failed to fetch owned postage accounts:', netId, error);
                setError('Failed to fetch owned postage accounts');
            });

        fetchPostageAccountsByAuthorizedUserNetId(netId)
            .then(setAuthorizedAccounts)
            .catch(error => {
                console.error('Failed to fetch authorized postage accounts:', netId, error);
                setError('Failed to fetch authorized postage accounts');
            });
    }, [netId]);

    if (error) {
        return <div className="alert alert-danger" role="alert">{error}</div>;
    }

    return (
        <div className="container mt-3">
            <div className="page-header"><h1 className="gradient-under">Postage Accounts for {netId}</h1></div>
            <p>Here you will find all Postage Accounts that you own, and all Postage Accounts that you are an authorized user on. Click an account to view it's details or manage the account.</p>
            <h2 className="h3 mb-4">Owned Accounts</h2>
            <AccountTable accounts={ownedAccounts} />
            <hr />
            <h2 className="h3 mb-4">Authorized Accounts</h2>
            <AccountTable accounts={authorizedAccounts} />
        </div>
    );
}


export default CurrentPostageAccounts;
